<button
	type="button"
	pButton
	class="p-button-rounded p-button-sm p-button-text"
	[icon]="ressource.fav_date_creation? 'pi pi-star-fill' : 'pi pi-star'"
	[loading]="loading"
	(click)="toggleFavoris($event)"
></button>
